import { render, staticRenderFns } from "./TranslationsButton.vue?vue&type=template&id=f9151d48&scoped=true&"
import script from "./TranslationsButton.vue?vue&type=script&lang=ts&"
export * from "./TranslationsButton.vue?vue&type=script&lang=ts&"
import style0 from "./TranslationsButton.vue?vue&type=style&index=0&id=f9151d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9151d48",
  null
  
)

export default component.exports